<template>
  <div class="animated fadeIn">
    <div class="card">
      <div class="card-header">
        List of Subscribers
      </div>
      <div class="card-body">
        <span v-if="isLoading">Loading..</span>
        <span v-if="(!subscribers || subscribers.length === 0) && !isLoading">No Subscribers</span>
        <table class="table table-hover table-bordered" v-if="subscribers && subscribers.length">
          <thead class="thead-dark">
            <tr>
              <th scope="col">Name</th>
              <th scope="col">Email</th>
              <th scope="col">Status</th>
              <th scope="col">Date</th>
              <th scope="col">Actions</th>
            </tr>
          </thead>
          <tbody>
            <tr :key="subscriber._id" v-for="(subscriber, index) in subscribers">
              <td>
                <span>{{ subscriber.name }}</span>
              </td>
              <td>{{ subscriber.email }}</td>
              <td> 
                <span class="badge" :class="{'badge-success rounded-pill': subscriber.active, 'badge-warning rounded-pill': !subscriber.active}">{{ (subscriber.active) ? 'active' : 'inactive' }}</span>
              </td>
              <td>{{ subscriber.created | moment('YYYY-MM-DD') }}</td>
              <td class="text-center">
                <router-link :to="{ name: 'Edit subscriber', params: { _id: subscriber._id }}">
                  <span class="fa fa-eye mr-2"></span>
                </router-link>
                <router-link :to="{ name: 'Edit subscriber', params: { _id: subscriber._id }}">
                  <span class="fa fa-edit mr-2"></span>
                </router-link>
                <a href="#delete" @click="deleteAction = { showModal: true, subscriber: subscriber}">
                  <span class="fa fa-minus-circle text-danger"></span>
                </a>
              </td>
            </tr>
          </tbody>
        </table>
        <div class="confirm-subscriber-modal">
          <modal v-if="deleteAction.showModal" @close="deleteAction.showModal = false">
            <h3 slot="header">Confirm delete Subscriber</h3>
            <p slot="body">Are you sure you want to delete the selected subscriber?</p>
            <div slot="footer">
              <a href="#" class="btn btn-outline-info" data-dismiss="modal" @click="deleteAction.showModal = false">Cancel</a>
              <a href="#" class="btn orange-btn-custom" data-dismiss="modal" @click="deleteSubscriber(deleteAction.subscriber)">Delete Subscriber</a>
            </div>
          </modal>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Vuex from 'vuex'
import Dialog from '@/components/Dialog'

export default {
  name: 'ListSubscribersAdmin',
  components: { 'modal': Dialog },
  data() {
    return {
      isLoading: true,
      subscribers: null,
      deleteAction: {
        showModal: false,
        subscriber: null
      }
    }
  },
  created: function() {
    this.fetchData().then(subscribers => (this.subscribers = this.populateSubscribers(subscribers)))
  },
  computed: {
    ...Vuex.mapGetters(['currentSubscriber'])
  },
  methods: {
    fetchData() {
      return this.$http
        .get('subscription/admin')
        .then(
          response => {
            this.isLoading = false
            return response.data
          },
          () => {
            this.isLoading = false
          }
        )
    },
    populateSubscribers(subscribers) {
      // Prepare data for each subscriber update set
      return subscribers
    },
    deleteSubscriber(subscriber) {
      // Hide Modal
      console.log(subscriber._id)
      this.deleteAction.showModal = false
      this.$http.delete(`subscription/admin/${subscriber._id}`)
        .then(
          response => {
            this.fetchData().then(subscribers => (this.subscribers = this.populateSubscribers(subscribers)))
          },
          () => {
            // error callback
            this.showErrorMessage('Sorry but an error occurred when submitting form')
          }
        )
    }
  }
}
</script>
<style>
.badge-success{
    background-color: rgb(26, 146, 26);
    color: white;
  }
  .badge-danger{
    background-color: rgb(250, 243, 43);
    color: rgb(194, 188, 188);
  }
  .badge-warning{
    background-color: rgb(232, 133, 79);
    color: white;
  }
  .badge-info{
    background-color: rgb(77, 84, 215);
    color: white;
  }
  .badge-secondary{
    background-color: rgb(69, 70, 72);
    color: white;
  }
  </style>
<style scoped>
  .fa {
    font-size: 16px;
  }
  .table tbody {
    border-top: 2px solid #dadae1 !important;
  }
  .table td .line-versions {
    width: 80%;
    height: 25px;
    border-bottom: 1px solid #dadae1;
    display: inline-block;
    border-left: 1px solid #dadae1;
    top: -12px;
    position: relative;
    right: -12px;
  }
</style>



// WEBPACK FOOTER //
// src/admin/views/subscriber/ListSubscribers.vue